var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import EdModal from "@frameworks/shared-library/components/edModal";
import SalesRating from "@frameworks/salesjourney/components/Generic/SalesRating";
import { dashboardRatingMsg, removeLocalStorageDataIfExist, } from "@frameworks/salesjourney/components/constant";
import profileDI from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import { getLocalISOString } from "@domains/utils/reportDates";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import Header from "@frameworks/salesjourney/components/Header/Header";
import NavigationSidebar from "@frameworks/salesjourney/components/Sidebar/NavigationSidebar";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { useNavigate } from "react-router-dom";
import filterDI from "@frameworks/salesjourney/components/filterDi/serviceLocator";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { ECurrentLoginComponent } from "@domains/salesFeatures/Login/entities/iLogin";
import { ERole } from "@frameworks/salesjourney/components/Login/Login";
var DashboardHOC = function (props) {
    var _a = props.allowRatingFunctionCall, allowRatingFunctionCall = _a === void 0 ? false : _a, _b = props.isHeaderVisible, isHeaderVisible = _b === void 0 ? true : _b, _c = props.isSidebarVisible, isSidebarVisible = _c === void 0 ? true : _c;
    var navigate = useNavigate();
    var _d = __read(React.useState(false), 2), showSalesRating = _d[0], setShowSalesRating = _d[1];
    var _e = __read(useState(true), 2), isShowHeader = _e[0], setIsShowHeader = _e[1];
    var _f = __read(useState(true), 2), isShowSidebar = _f[0], setIsShowSidebar = _f[1];
    var _g = __read(useState(false), 2), showLogoutAllDpopup = _g[0], setShowLogoutAllDpopup = _g[1];
    var handleSubmitDashboardFeedback = function (ratingFlag, selectedStars, commentText) {
        profileDI.profile.saveDashboardFeedback({
            submodule_code: props === null || props === void 0 ? void 0 : props.dashboardId,
            rating_date: getLocalISOString(new Date()),
            rating_flg: ratingFlag,
            rating: selectedStars ? selectedStars : 0,
            remarks: commentText ? commentText : "",
        });
    };
    var getSalesRatingData = function () {
        profileDI.profile
            .getValidateFeedbackData({ submoduleCode: props === null || props === void 0 ? void 0 : props.dashboardId })
            .then(function (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.showFeedbackPopup) {
                setShowSalesRating(resp === null || resp === void 0 ? void 0 : resp.showFeedbackPopup);
            }
            else {
                setShowSalesRating(false);
            }
        })
            .catch(function (err) {
            setShowSalesRating(false);
        });
    };
    var redirectToLoginPage = function () {
        filterDI.filter.updateFinalFilterState({});
        filterDI.filter.updateNRProductList([]);
        removeLocalStorageDataIfExist([
            ELocalStorageKeys.AccessToken,
            ELocalStorageKeys.IsRHAbove,
            ELocalStorageKeys.LoginType,
            ELocalStorageKeys.PartnerCategory,
            ELocalStorageKeys.CadCam,
            ELocalStorageKeys.LeaddashFilterdata,
        ]);
        loginDI.login.clearLoginToken();
        // window.location.href = URLConfig.config.applicationFolder + "login";
        navigate("/login");
    };
    var logoutUser = function (logoutAllD) {
        if (logoutAllD === void 0) { logoutAllD = false; }
        var logoutPayload = {
            flgLogoutAllD: logoutAllD,
        };
        loginDI.login.changeCurrentLoginComponent({
            currentComponent: ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS,
            extraConfig: {
                currentActiveTab: ERole.RM,
            },
        });
        loginDI.login
            .logoutUser(logoutPayload)
            .then(function (resp) {
            redirectToLoginPage();
        })
            .catch(function (error) {
            redirectToLoginPage();
        });
    };
    var logoutFromAllDevices = function () {
        if (loginDI.login.getIsRMPartnerFRM().isPartner) {
            logoutUser();
        }
        else {
            setShowLogoutAllDpopup(true);
        }
    };
    useEffect(function () {
        var _a = loginDI.login.getIsRMPartnerFRM(), isFRM = _a.isFRM, isRM = _a.isRM;
        if ((isFRM || isRM) && !!props.dashboardId && allowRatingFunctionCall) {
            getSalesRatingData();
        }
    }, [props === null || props === void 0 ? void 0 : props.dashboardId]);
    useEffect(function () {
        setIsShowHeader(isHeaderVisible);
    }, [isHeaderVisible]);
    useEffect(function () {
        setIsShowSidebar(isSidebarVisible);
    }, [isSidebarVisible]);
    return (React.createElement(React.Fragment, null,
        isShowSidebar && React.createElement(NavigationSidebar, null),
        React.createElement("div", { className: "d-flex flex-column right-side-content-screen" },
            isShowHeader && (React.createElement(Header, { redirectToLoginPage: redirectToLoginPage, logoutUser: logoutFromAllDevices })),
            React.createElement(props.component, __assign({}, props, { redirectToLoginPage: redirectToLoginPage, logoutUser: logoutFromAllDevices, component: props === null || props === void 0 ? void 0 : props.subComponentOne }))),
        React.createElement("div", { className: "rating-modal" }, showSalesRating && (React.createElement(EdModal, { show: showSalesRating, setShow: function () {
                setShowSalesRating(false);
                handleSubmitDashboardFeedback(false);
            }, showFooter: false, title: "Rate Us", children: React.createElement(SalesRating, { setShowSalesRating: setShowSalesRating, ratingText: dashboardRatingMsg[props === null || props === void 0 ? void 0 : props.dashboardId], onSubmit: handleSubmitDashboardFeedback }), modalTitle: "", size: "modal-dialog-centered", hideCloseBtn: true }))),
        showLogoutAllDpopup && (React.createElement(EdModal, { show: showLogoutAllDpopup, setShow: setShowLogoutAllDpopup, showFooter: false, modalTitle: "", children: React.createElement(React.Fragment, null,
                React.createElement("div", { className: "d-flex flex-column pb-4" },
                    React.createElement("div", { className: "d-flex align-items-center justify-content-center pb-5" },
                        React.createElement("span", { className: "DMSansMedium_18_500 txt-midnight-blue" }, "Logout from Device")),
                    React.createElement("div", { className: "d-flex justify-content-evenly" },
                        React.createElement(EdButton, { btnTyp: "grey-one", value: "Current Device", className: "neomorphic-btn ", onClick: function () { return logoutUser(false); } }),
                        React.createElement(EdButton, { btnTyp: "blue-one", value: "All Devices", className: " neomorphic-btn", onClick: function () { return logoutUser(true); } })))), size: "change-password-modal" }))));
};
export default DashboardHOC;
